import { FC, memo } from 'react'
import { Stack, Text, useColorModeValue } from '@chakra-ui/react'

import { CloudUpload } from 'components/icons'
import { convertBytesNumberToString } from 'utils/transforms/number'

type Props = {
  extensions: string[]
  maxSize?: number
  minSize?: number
}

const DropzoneContent: FC<Props> = ({ minSize, maxSize, extensions }) => {
  const textColor = useColorModeValue('gray.500', 'whiteAlpha.600')
  return (
    <Stack align="center">
      <CloudUpload className="accessible" boxSize={{ base: 8, sm: 8, md: 12, lg: 12 }} />

      <Stack spacing={1}>
        <Text textAlign="center" fontSize="lg">
          Clique aqui para subir arquivos
        </Text>
        {maxSize && (
          <Text textAlign="center" color={textColor}>
            Tamanho máximo dos arquivos: {convertBytesNumberToString(maxSize)}
          </Text>
        )}
        {minSize && (
          <Text textAlign="center" color={textColor}>
            Tamanho mínimo dos arquivos: {convertBytesNumberToString(minSize)}
          </Text>
        )}
        {extensions.length !== 0 && (
          <Text textAlign="center" color={textColor}>
            Arquivos permitidos: {extensions.join(', ')}
          </Text>
        )}
      </Stack>
    </Stack>
  )
}

export default memo(DropzoneContent)
